import { useTranslation } from "react-i18next"
import { ConfigStatus } from "./ObjectModelConfigMain"

const QuadriFooterNewProject = (props: {
  configStatus: ConfigStatus
  isEnableButtonDisabled?: boolean
  submitQuadriProject: (e: any) => void
}) => {
  const { configStatus, isEnableButtonDisabled } = props
  const { submitQuadriProject } = props
  const closeModal = () => window.location.reload()
  const { t } = useTranslation("config")

  return (
    <footer>
      <div className="col-12 head-container mt-3">
        <div className="page-heading mt-0">
          <div className="wrap-buttons mr-1">
            <button className="button link-secondary mr-1 ml-auto" onClick={closeModal}>
              {t("objectModelConfig.cancel")}
            </button>
            <QuadriActionButton
              configStatus={configStatus}
              isButtonDisabled={isEnableButtonDisabled}
              submitQuadriProject={submitQuadriProject}
            />
          </div>
        </div>
      </div>
    </footer>
  )
}

const QuadriActionButton = (props: {
  configStatus: ConfigStatus
  isButtonDisabled?: boolean
  submitQuadriProject: (e: any) => void
}) => {
  const { configStatus, isButtonDisabled, submitQuadriProject } = props
  const { t } = useTranslation("config")
  return (
    <button
      className={configStatus === "Creating" ? "button primary icon-left" : "button primary"}
      onClick={submitQuadriProject}
      disabled={isButtonDisabled}
      data-testid="quadri-action-button"
    >
      {configStatus === "Creating" ? (
        <>
          <i className="icon-font tc-icon-spinner-light"></i>
          {t("objectModelConfig.working")}
        </>
      ) : (
        t("objectModelConfig.submit")
      )}
    </button>
  )
}

export default QuadriFooterNewProject
